import MessageList from "./MessageList";
import MessageEdit from "./MessageEdit";

export default {
    list: MessageList,
    edit: MessageEdit,
    create: MessageEdit
}
